<template>
  <div class="group-setup">
    <v-progress-linear
      indeterminate
      color="orange"
      v-if="loading"
    ></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <v-card class="pa-5">
      <v-card-title dark>
        <h3 class="ma-2">Online Training /LCI Institute / Local Training</h3>
      </v-card-title>
      <v-divider></v-divider>
      <v-form>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-text-field
              outlined
              dense
              v-model="form.online_training_number_of_modules"
              label="Online training number of modules*"
              required
              type="number"
            ></v-text-field>
          </v-col>      
          <v-col cols="6" md="6" sm="12">
            <v-text-field
              outlined
              dense
              v-model="form.lci_institute_number_of_modules"
              label="LCI Institute number of modules*"
              required
              type="number"
            ></v-text-field>
          </v-col>   
        </v-row>
        <v-row>          
          <v-col cols="6" md="6" sm="12">
            <v-text-field
              outlined
              dense
              v-model="form.local_training_number_of_modules"
              label="Local Training number of modules*"
              required
              type="number"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-file-input
              outlined
              dense
              filled
              v-model="form.document1"
              prepend-icon="mdi-paperclip"
              label="Please upload pdf or image"
            ></v-file-input>
            <small>Max Size 2Mb </small>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <v-file-input
              outlined
              dense
              filled
              v-model="form.document2"
              prepend-icon="mdi-paperclip"
              label="Please upload pdf or image"
            ></v-file-input>
            <small>Max Size 2Mb </small>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-file-input
              outlined
              dense
              filled
              v-model="form.document3"
              prepend-icon="mdi-paperclip"
              label="Please upload pdf or image"
            ></v-file-input>
            <small>Max Size 2Mb </small>
          </v-col>
          <v-col cols="6" md="6" sm="12">
            <v-file-input
              outlined
              dense
              filled
              v-model="form.document4"
              prepend-icon="mdi-paperclip"
              label="Please upload pdf or image"
            ></v-file-input>
            <small>Max Size 2Mb </small>
          </v-col>
        </v-row>
      </v-form>
      <v-divider></v-divider>
      <v-card-actions v-if="!cpRole">
        <v-row>
          <v-col cols="12" md="9" xs="6"></v-col>
          <v-col cols="12" md="3" xs="6">
            <v-btn
              large
              color="success"
              depressed
              :disabled="loading || !form.lci_institute_number_of_modules"
              block
              @click="submit()"
              >Submit to Review</v-btn
            >
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <Snackbars
      :text="successMsg"
      :snackbar="snackbar"
      :color="'success'"
      @classSnackbar="closeSnackbar"
    />
  </div>
</template>

<script>

import Alert from "@/components/shared/Alert";
import Snackbars from "@/components/shared/Snackbars";
import { ActivityService } from "../../../services/activity-service.js";
import { checkError } from "@/config/errors.js";

export default {
  name: "Trainings",
  components: { Alert, Snackbars},
  data: () => ({
    cpRole: false,
    loading: false,
    errors: null,
    snackbar: false,
    successMsg: "",
    form: {
      online_training_number_of_modules: "",
      lci_institute_number_of_modules: "",
      local_training_number_of_modules: "",
      document1: null,
      document2: null,
      document3: null,
      document4: null,
    },
  }),

  mounted() {},  

  methods: {
     submit() {
      this.errors = null;
      this.loading = true;
      this.snackbar = false;
      let fd = new FormData();
     
       fd.append(
        "document1",
        this.form.document1
      );
       fd.append(
        "document2",
        this.form.document2
      );
       fd.append(
        "document3",
        this.form.document3
      );
       fd.append(
        "document4",
        this.form.document4
      );
      fd.append(
        "local_training_number_of_modules",
        this.form.local_training_number_of_modules
      );
      fd.append(
        "lci_institute_number_of_modules",
        this.form.lci_institute_number_of_modules
      );
      fd.append(
        "online_training_number_of_modules",
        this.form.online_training_number_of_modules
      );
      fd.append("month", this.$route.params.month);
      fd.append("key", "TRAINING");
    
      let data = fd;
      ActivityService.submitActivity('online-training', data)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {           
            this.$router.push("/activities/monthly"); 
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
    onDismissed() {
      this.errors = null;
    },
    closeSnackbar() {
      this.snackbar = false;
    },
    reset() {
      this.form.name = "";
    },
  },
};
</script>
